export const theme = {
    primary: "#1FBC6C",
    onPrimary: "#f9f9f9",
    secondary: "#54BD95",
    onSecondary: "#FFFFFF",
    primaryFixed: "#DEEFE8",
    secondaryFixed: "#A6A6A6",
    onSurface: "#191A15",
}